import React, { Component } from 'react'
import { ListGroup, ListGroupItem, } from 'reactstrap'
import { db } from '../../../config/firebaseconfig'
import has from 'mout/object/has'
import sortByPropText from '../../../helpers/content/manageSets/sortByPropText'
import forOwn from 'mout/object/forOwn'
import UtilSearchBar from '../../Util/UtilSearchBar'

/*
  <StudentsNotInClassList 
    thisClass={thisClass}
    students={this.props.students}
  />
*/

class StudentsNotInClassList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      search: ''
    }

    this.handleChange = this.handleChange.bind(this)
  }

  addStudentToClass(studentId) {
    const thisClass = this.props.thisClass
    const batch = db.batch()
    const thisClassRef = db.collection('classes').doc(thisClass.id)
    const studentRef = db.collection('students').doc(studentId)
    const classUpdateKey = `students.${studentId}`
    const studentUpdateKey = `classes.${thisClass.id}`
    batch.update(thisClassRef, {[classUpdateKey]: true})
    batch.update(studentRef, {[studentUpdateKey]: true})
    batch.commit()
      .then()
      .catch((err) => console.log(err))
  }

  handleChange(e) {
    this.setState({[e.target.name]: e.target.value})
  }

  render() {
    const thisClass = this.props.thisClass
    const students = this.props.students
    const schools = this.props.schools
    let school
    let studentsNotInClassListGroupItems = []
    if (schools && thisClass) {
      school = schools[thisClass.school]
      let studentsNotInClass = []
      // All students in school who
      if (school.students && thisClass.students) {
        forOwn(school.students, (check, studentId) => {
          if (check && students[studentId] && !thisClass.students[studentId]) {
            const student = students[studentId]
            const search = this.state.search.toLowerCase()
            if (student.fullName.toLowerCase().search(search) > -1) {
              studentsNotInClass.push(students[studentId])
            }
          }
        })
      } else if (school.students) {
        forOwn(school.students, (check, studentId) => {
          if (check && students[studentId]) {
            const student = students[studentId]
            const search = this.state.search.toLowerCase()
            if (student.fullName.toLowerCase().search(search) > -1) {
              studentsNotInClass.push(students[studentId])
            }
          }
        })
      }
      if (studentsNotInClass.length > 0) {
        const sortedStudentsNotInClass = sortByPropText(studentsNotInClass, 'lastName')
        sortedStudentsNotInClass.forEach((student) => {
          studentsNotInClassListGroupItems.push(
            <ListGroupItem
              key={`notInClass${student.id}`}
              className={'m2clickable'}
              onClick={() => this.addStudentToClass(student.id)}
            >
              {`+ ${student.fullName}`}
            </ListGroupItem>
          )
        })
      }
    if (studentsNotInClassListGroupItems === []) {
      studentsNotInClassListGroupItems = null
    }


    }

    /*
      pull all of the students who are in the school but not in the class
    */


    return (
      <div>
        <p>Students Not In Class</p>
        <UtilSearchBar 
          searchIconQ={true}
          searchButtonQ={true}
          searchIconText={'Search'}
          placeholder={'Search students not in this class...'}
          handleChange={this.handleChange}
          buttonColor='primary'
          val={this.state.search}
          name={'search'}
        />
        <ListGroup>
          {studentsNotInClassListGroupItems}
        </ListGroup>
      </div>
    )
  }
}

export default StudentsNotInClassList


// WEBPACK FOOTER //
// ./src/components/Users/AddStudentsToClasses/StudentsNotInClassList.js